import { render, staticRenderFns } from "./stencil.vue?vue&type=template&id=7875965e&scoped=true&"
import script from "./stencil.vue?vue&type=script&lang=js&"
export * from "./stencil.vue?vue&type=script&lang=js&"
import style0 from "./stencil.vue?vue&type=style&index=0&id=7875965e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7875965e",
  null
  
)

export default component.exports